import { useEffect, useState } from 'react';
import { subscribeToasts, type ToastEntry } from '../../lib/toast';

const DOT_COLOR: Record<ToastEntry['kind'], string> = {
  info: 'bg-ink-700',
  success: 'bg-brand-500 shadow-[0_0_8px_rgba(16,185,129,0.6)]',
  error: 'bg-danger',
};

export function ToastViewport() {
  const [toasts, setToasts] = useState<ToastEntry[]>([]);
  useEffect(() => subscribeToasts(setToasts), []);

  return (
    <div
      className="pointer-events-none fixed bottom-6 right-6 z-50 flex flex-col gap-2"
      role="region"
      aria-label="알림"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          role="status"
          className="pointer-events-auto flex max-w-sm items-center gap-2.5 rounded-full border border-ink-200 bg-paper py-2 pl-3 pr-4 text-[13px] text-ink-900 shadow-pop"
        >
          <span
            aria-hidden="true"
            className={`inline-block h-2 w-2 rounded-full ${DOT_COLOR[t.kind]}`}
          />
          <span className="leading-[1.4]">{t.message}</span>
        </div>
      ))}
    </div>
  );
}
